<template>
<div>
    <section class="d-flex flex-column h-full">
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>
    </section>


  <div id="tab1" class="t-color-content1 pdt-16 pdb-16 pdl-16 pdr-16 ripple-item ">
    <div v-if="badge" class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default ">
        <div class="rewardTitle">
          <p class="font-b mgt-1 mgb-1 t-color-title ">{{$t('1518')}}</p>
        </div>
        <div class="rewardContent pda-default d-flex justify-content-center flex-column">
          <div class="crownWrapper position-relative d-flex align-items-center flex-column">
            <img src="images/reward/crown-top.png" alt="" class="crown120">
            <img src="images/reward/crown-shadow.png" alt="" class="shadow82">
          </div>
          <div class="t-color-content1 t-body3 mgt-22 mgb-34 t-center">10개 온라인 강의 수료</div>
          <a class="d-flex align-items-center justify-content-end content-color" href="#"><span class="pdr-8 t-body2 content-color">{{$t('1704')}}</span><i class="material-icons content-color">navigate_next</i></a>
        </div>
    </div>

    <div v-else class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pdt-16 pdb-8 pdl-16 pdr-16 ">
        <div class="rewardTitle">
          <p class="font-b mgt-1 mgb-1 t-color-title ">{{$t('1518')}}</p>
        </div>
        <div class="rewardContent pda-default d-flex justify-content-center flex-column">
          <div class="crownWrapper position-relative d-flex align-items-center flex-column mgb-16">
            <img src="images/reward/badge1.png" alt="" class="badge80">
          </div>
          <div class="t-color-title t-subtitle3 mgt-36 mgb-8 t-center font-r">{{$t('1707')}}</div>
          <div class="t-color-gray2 t-body3 mgt-0 mgb-0 t-center l-spacing42">{{$t('1708')}}</div>
        </div>
    </div>

    <div v-if="certificate" class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default ">
        <div class="rewardTitle">
          <p class="font-b mgt-1 mgb-1 t-color-title ">{{$t('1705')}}</p>
        </div>
        <div class="rewardContent pda-default d-flex justify-content-center flex-column">
          <div class="crownWrapper position-relative d-flex align-items-center flex-column">
            <img :src="certificate.image" alt="" class="cert138">
            <img src="images/reward/crown-shadow.png" alt="" class="shadow112">
          </div>
          <div class="t-color-content1 t-body3 mgt-22 mgb-34 t-center">{{certificate.name}}</div>
          <a class="d-flex align-items-center justify-content-end content-color" href="#"><span class="pdr-8 t-body2 content-color">{{$t('1706')}}</span><i class="material-icons content-color">navigate_next</i></a>
        </div>
    </div>
    <div v-else class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pdt-16 pdb-8 pdl-16 pdr-16 ">
        <div class="rewardTitle">
          <p class="font-b mgt-1 mgb-1 t-color-title ">{{$t('1705')}}</p>
        </div>
        <div class="rewardContent pda-default d-flex justify-content-center flex-column">
          <div class="crownWrapper position-relative d-flex align-items-center flex-column mgb-16">
            <img src="images/reward/badge2.png" alt="" class="badge80">
          </div>
          <div class="t-color-title t-subtitle3 mgt-36 mgb-8 t-center font-r">{{$t('1709')}}</div>
          <div class="t-color-gray2 t-body3 mgt-0 mgb-0 t-center l-spacing42">{{$t('1710')}}</div>
        </div>
    </div>
  </div>
</div>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import rewardApi from "@/api/rewardApi.js";

export default {
    name: 'reward',

    data() {
        return {
            // title
            leftBtnMethod: () => { this.$router.go(-1)},
            badge:null,
            certificate:null

        }
    },
    components: {
        TopAppBar,
    },

    mixins: [topAppBarMixin],

    watch: {
        '$route' (to, from) {
            
        }
    },
    mounted() {
        this.setTopAppBarBackSearch(this.$t('1517'))
        this.fetchData()
    },
    methods:{
        
        fetchData(){
        // 채팅 룸 정보(get chatting room list)
            rewardApi.rewardRecentBadge().then((response) => {
                console.log('responseBadge',response)
                this.badge = response.data.data
                // let list = response.data.data.content;
            
                // if (!list.length) {
                //     this.isNoData = true
                // }

            }).catch((err) => {
                
            })

            rewardApi.rewardRecentCertificate().then((response) => {
                console.log('responseRecent',response)
                this.certificate = response.data.data

            }).catch((err) => {
                
            })
            
        }
        
    }
    
}

</script>

<style scoped>
.nav-extended .brand-logo, .nav-content * {
      font-family: noto-regular;
    }
    .nav-extended .brand-logo{
      font-size:20px;
    }
  .tabs .tab a:focus, .tabs .tab a:focus.active {
      background-color: #F5F5F5;
      outline: none;
  }
  .content-color{
      color: #C30E2F;
  }
  .tabs .indicator{
    background:#C30E2F;
  }
  .mdc-elevation--z3 {
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
    background-color: #ffffff;
  }
  .rewardTitle{
    font-size:16px;
  }
  .crown120{
    max-width: 120px;
  }
  .shadow82{
    max-width: 90px;
    height: 30px;
  }
  .cert138{
    max-width:138px;
  }
  .shadow112{
    max-width: 138px;
    height: 30px;
  }
  .badge80{
      max-width:80px;
  }
  .l-spacing42{
    letter-spacing: -0.42px;
  }
</style>